export const benefices = [
  {
    key: 'benefices-confidentialite',
    title: 'Confidentialité totale',
    text: 'Vos échanges avec l’IA restent vos données : ni réutilisation, ni entraînement, ni exploitation commerciale.',
    iconFamily: 'fa-solid',
    icon: 'circle-check',
  },
  {
    key: 'benefices-conformite',
    title: 'Conformité RGPD native',
    text: 'Des rôles clairs (responsable de traitement, sous-traitants hébergés en UE) et des engagements écrits.',
    iconFamily: 'fa-solid',
    icon: 'circle-check',
  },
  {
    key: 'benefices-productivite',
    title: 'Productivité mesurable',
    text: 'Rédaction, analyse, recherche et synthèse accélérées : vos équipes se concentrent sur la valeur.',
    iconFamily: 'fa-solid',
    icon: 'circle-check',
  },
  {
    key: 'benefices-maitrise-couts',
    title: 'Coûts maîtrisés',
    text: 'Un abonnement clair par utilisateur, sans surprise, sans investissement matériel à prévoir.',
    iconFamily: 'fa-solid',
    icon: 'circle-check',
  },
  {
    key: 'benefices-independance',
    title: 'Indépendance technologique',
    text: 'Sans dépendance à des acteurs extra-européens : votre outil de travail reste sous votre contrôle.',
    iconFamily: 'fa-solid',
    icon: 'circle-check',
  },
  {
    key: 'benefices-accompagnement-humain',
    title: 'Accompagnement humain',
    text: 'Des experts réactifs, proches de vos préoccupations, disponibles 24h/24 et 7j/7.',
    iconFamily: 'fa-solid',
    icon: 'circle-check',
  },
]
